/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ConteneurFixeDto } from '../models/conteneur-fixe-dto';
import { ConteneurImmobileDto } from '../models/conteneur-immobile-dto';
import { ConteneurMobileDto } from '../models/conteneur-mobile-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des conteneurs mobiles
 */
@Injectable({
  providedIn: 'root',
})
export class ConteneursMobilesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation conteneurMobileGetList
   */
  static readonly ConteneurMobileGetListPath = '/api/conteneurs-mobiles/list';

  /**
   * Renvoie la liste des conteneurs mobiles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobileGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurMobileGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ConteneurMobileDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobileGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ConteneurMobileDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des conteneurs mobiles.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobileGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurMobileGetList(params?: {
  }): Observable<Array<ConteneurMobileDto>> {

    return this.conteneurMobileGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ConteneurMobileDto>>) => r.body as Array<ConteneurMobileDto>)
    );
  }

  /**
   * Path part for operation conteneurMobileLoadList
   */
  static readonly ConteneurMobileLoadListPath = '/api/conteneurs-mobiles/load-list';

  /**
   * Renvoie la liste des conteneurs mobiles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobileLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobileLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobileLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des conteneurs mobiles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobileLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobileLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.conteneurMobileLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation conteneurMobileGet
   */
  static readonly ConteneurMobileGetPath = '/api/conteneurs-mobiles/{id}';

  /**
   * Renvoie le conteneur mobile spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurMobileGet$Response(params: {

    /**
     * Identifiant du conteneur mobile
     */
    id: number;
  }): Observable<StrictHttpResponse<ConteneurMobileDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobileGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurMobileDto>;
      })
    );
  }

  /**
   * Renvoie le conteneur mobile spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurMobileGet(params: {

    /**
     * Identifiant du conteneur mobile
     */
    id: number;
  }): Observable<ConteneurMobileDto> {

    return this.conteneurMobileGet$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurMobileDto>) => r.body as ConteneurMobileDto)
    );
  }

  /**
   * Path part for operation conteneurMobilePut
   */
  static readonly ConteneurMobilePutPath = '/api/conteneurs-mobiles/{id}';

  /**
   * Met à jour le conteneur mobile spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobilePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobilePut$Response(params: {

    /**
     * Identifiant du conteneur mobile à mettre à jour
     */
    id: number;

    /**
     * Conteneur mobile
     */
    body: ConteneurMobileDto
  }): Observable<StrictHttpResponse<ConteneurFixeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobilePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurFixeDto>;
      })
    );
  }

  /**
   * Met à jour le conteneur mobile spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobilePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobilePut(params: {

    /**
     * Identifiant du conteneur mobile à mettre à jour
     */
    id: number;

    /**
     * Conteneur mobile
     */
    body: ConteneurMobileDto
  }): Observable<ConteneurFixeDto> {

    return this.conteneurMobilePut$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurFixeDto>) => r.body as ConteneurFixeDto)
    );
  }

  /**
   * Path part for operation conteneurMobileDelete
   */
  static readonly ConteneurMobileDeletePath = '/api/conteneurs-mobiles/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobileDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurMobileDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobileDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobileDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurMobileDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.conteneurMobileDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation conteneurMobilePost
   */
  static readonly ConteneurMobilePostPath = '/api/conteneurs-mobiles';

  /**
   * Crée le conteneur mobile spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobilePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobilePost$Response(params: {

    /**
     * Conteneur mobile
     */
    body: ConteneurMobileDto
  }): Observable<StrictHttpResponse<ConteneurMobileDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurMobileDto>;
      })
    );
  }

  /**
   * Crée le conteneur mobile spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobilePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobilePost(params: {

    /**
     * Conteneur mobile
     */
    body: ConteneurMobileDto
  }): Observable<ConteneurMobileDto> {

    return this.conteneurMobilePost$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurMobileDto>) => r.body as ConteneurMobileDto)
    );
  }

  /**
   * Path part for operation conteneurMobileDesactivate
   */
  static readonly ConteneurMobileDesactivatePath = '/api/conteneurs-mobiles/{id}/desactivate';

  /**
   * Désactive le conteneur mobile spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobileDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobileDesactivate$Response(params: {

    /**
     * Identifiant du conteneur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ConteneurMobileDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobileDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le conteneur mobile spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobileDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobileDesactivate(params: {

    /**
     * Identifiant du conteneur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ConteneurMobileDto
  }): Observable<number> {

    return this.conteneurMobileDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation conteneurMobileImmobilesLoadList
   */
  static readonly ConteneurMobileImmobilesLoadListPath = '/api/conteneurs-mobiles/immobiles/load-list';

  /**
   * Renvoie la liste des conteneurs immobiles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobileImmobilesLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobileImmobilesLoadList$Response(params: {

    /**
     * Filtre sur le délai minimum (en jours)
     */
    delaiMinimum?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobileImmobilesLoadListPath, 'post');
    if (params) {
      rb.query('delaiMinimum', params.delaiMinimum, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des conteneurs immobiles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobileImmobilesLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobileImmobilesLoadList(params: {

    /**
     * Filtre sur le délai minimum (en jours)
     */
    delaiMinimum?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.conteneurMobileImmobilesLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation conteneurMobileGetConteneurImmobile
   */
  static readonly ConteneurMobileGetConteneurImmobilePath = '/api/conteneurs-mobiles/immobiles/{id}';

  /**
   * Renvoie le conteneur immobile spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobileGetConteneurImmobile()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurMobileGetConteneurImmobile$Response(params: {

    /**
     * Identifiant du conteneur immobile
     */
    id: number;
  }): Observable<StrictHttpResponse<ConteneurImmobileDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobileGetConteneurImmobilePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurImmobileDto>;
      })
    );
  }

  /**
   * Renvoie le conteneur immobile spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobileGetConteneurImmobile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurMobileGetConteneurImmobile(params: {

    /**
     * Identifiant du conteneur immobile
     */
    id: number;
  }): Observable<ConteneurImmobileDto> {

    return this.conteneurMobileGetConteneurImmobile$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurImmobileDto>) => r.body as ConteneurImmobileDto)
    );
  }

  /**
   * Path part for operation conteneurMobileSetNiveauRemplissage
   */
  static readonly ConteneurMobileSetNiveauRemplissagePath = '/api/conteneurs-mobiles/{id}/niveau_remplissage';

  /**
   * Modification du niveau de remplissage d'un conteneur.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurMobileSetNiveauRemplissage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobileSetNiveauRemplissage$Response(params: {

    /**
     * Identifiant du conteneur
     */
    id: number;

    /**
     * Niveau de remplissage
     */
    body: number
  }): Observable<StrictHttpResponse<ConteneurMobileDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursMobilesService.ConteneurMobileSetNiveauRemplissagePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurMobileDto>;
      })
    );
  }

  /**
   * Modification du niveau de remplissage d'un conteneur.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurMobileSetNiveauRemplissage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurMobileSetNiveauRemplissage(params: {

    /**
     * Identifiant du conteneur
     */
    id: number;

    /**
     * Niveau de remplissage
     */
    body: number
  }): Observable<ConteneurMobileDto> {

    return this.conteneurMobileSetNiveauRemplissage$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurMobileDto>) => r.body as ConteneurMobileDto)
    );
  }

}
